import React, { useEffect, useRef, useMemo, useState } from "react";
import SelectionBlock from "../../accountDetailsSharedBlocks/SelectionBlock";
import PaymentBlock from "../../accountDetailsSharedBlocks/PaymentBlock";
import ViewPaymentMethodsClient from "../../../../utility/apiClients/customer/ViewPaymentMethodsClient";
import { useSelector, useDispatch } from "react-redux";
import OverLayLoader from "../../../loader/overlayLoader";
import Loader from "../../../loader";
import { easyPayCalculate } from "../../../../utility/features/helpers/accountHelper";
import labelsData from "../../../../json/fallbackglobalvariables.json";
import styles from "../../../../styles/enroll.module.scss";
import { Link } from "react-router";
import accountDetails from "../../../../utility/apiClients/account/accountDetailsClient";
import { setCustomerDetails } from "../../../../reduxStore/myAccount/getCustomerDetails";
import Globals, { URLS } from "../../../../utility/constants/appConstants";
import { customerServiceNumberFormatted } from '../../../../utility/utils/formatter';
import { PrepayNewPaymentMethodV2, PrepayExistingPaymentMethodV2 } from "../../../../utility/apiClients/account/prePayOTPaymentClient";
import NoEasyPayService from "../../accountSettings/easypay-settings/noEasyPayServices";
import tempJson from "../../../../json/fallbackglobalvariables.json";
import {setBypassAccountDetailsCache} from "../../../../reduxStore/myAccount/accountSummarySlice";
import ErrorBlock from '../../../errorMessage';
import missionStatusClient from '../../../../utility/apiClients/user/missionStatusClient';

const label = labelsData.acc;

const Enroll = (props) => {
  const dispatch = useDispatch();

  const labels = useMemo(() => tempJson.acc, []);

  const missionStatusCheck = async () => {
    try {
      const missionStatus = await missionStatusClient();
      return !["yes"].includes(String(missionStatus?.data).trim().toLowerCase());
    } catch (err) {
      console.error("Error checking mission status api:", err);
      return false;
    }
  };

  const { customerDetails } = useSelector(
    (state) => state.getCustomerDetails || {}
  );
  const selectedInvoiceRef = useRef(null);
  const allCustomersApiCalled = useSelector((state) => state.login.allCustomersApiCalled);   
  const [isLoading, setIsLoading] = useState(false);
  const [paymentData, setPaymentData] = useState([]);
  const [check, setCheck] = useState([]);
  const [isPaymentSubmitted, setIsPaymentSubmitted] = useState(false);
  const customerSummary = useSelector((state) => state.login.customerInfo);
  const [isLoadingSelectionBlock, setIsLoadingSelectionBlock] = useState(true);
  const selectedServiceAddress = useSelector(
    (state) => state.accountSummary.selectedServiceAddress
  );
  const [hasSelection, setHasSelection] = useState(false);
  const [error, setErrorMsg] = useState("");
  const custNumbers = useMemo(
    () => JSON.parse(localStorage.getItem("customerNumbers")) || [],
    []
  );

  const [serviceAddress, customerNumber] = useMemo(() => {
    let custNumber = "";
    let serviceAddr = "";
    if (selectedServiceAddress != null) {
      [serviceAddr, custNumber] = selectedServiceAddress.split(" | ");
    } else {
      custNumber = customerSummary ? customerSummary[0].CustomerNumber : "";
      serviceAddr = customerSummary
        ? customerSummary[0].ServiceAddresses[0].address
        : "";
    }
    return [serviceAddr, custNumber];
  }, [selectedServiceAddress, customerSummary]);

  useEffect(() => {
    if (customerNumber) {
      fetchPaymentData();
      
      if(allCustomersApiCalled)
        fetchSalesAgg();
    }

    return () => {
      setErrorMsg("");
      setIsLoadingSelectionBlock(true);
    }
  }, [customerNumber, allCustomersApiCalled]);

  
  const fetchSalesAgg = async () => {
    const isMissionAvailable = await missionStatusCheck();
    if (!isMissionAvailable) {
      setErrorMsg(Globals.acc.missionDownErrorDisplay);
      setIsLoadingSelectionBlock(false);
      return;
    }

    setErrorMsg("");
    setIsLoadingSelectionBlock(true);
    accountDetails(customerNumber ?? custNumbers[0], serviceAddress)
      .then((response) => {
        dispatch(setCustomerDetails(response));
        if (response?.SalesAgreements) {
          const { easyPaySvcAg, nonEasyPaySvcAg } = easyPayCalculate(response.SalesAgreements);
          setCheck(nonEasyPaySvcAg);
        } else if (response?.errorStatus === 424) {
          setErrorMsg("Some error occurred.");
        } 
      })
      .catch((error) => {
        setErrorMsg("Some error occured");
      }).finally(() => setIsLoadingSelectionBlock(false));
  };

  const fetchPaymentData = async () => {
    const isMissionAvailable = await missionStatusCheck();
    if (!isMissionAvailable) {
      setErrorMsg(Globals.acc.missionDownErrorDisplay);
      return;
    }

    setErrorMsg("");
    try {
      const paymentInfo = await ViewPaymentMethodsClient({
        cusNum: customerNumber,
      });
      const methods = paymentInfo?.data?.PaymentMethods || [];
      setPaymentData(methods);
    } catch (error) {
      setErrorMsg("Some error occured");
    }
  };

  
  const salesAgreements = check || customerDetails?.SalesAgreements;
    
  const makeSalesAgreementObj = (salesAgreements) => {
    let value = [];
    let data = {};
    salesAgreements.forEach((sa) => {
      if(selectedInvoiceRef.current !== null && selectedInvoiceRef.current?.[sa.salesAgrNum] === false)
        return;
      
      if(selectedInvoiceRef.current !== null && !Object.keys(selectedInvoiceRef.current).includes(sa.salesAgrNum))
        return;        

      value.push(sa.salesAgrNum);
      data = {...data, [sa.salesAgrNum]: sa };
    });

    return { value, data };
  }

  const handleSubmit = async (data, isNew) => {
    setIsLoading(true);
    setErrorMsg("");
    setIsPaymentSubmitted(true);

    const isMissionAvailable = await missionStatusCheck();
    if (!isMissionAvailable) {
      setErrorMsg(Globals.acc.missionDownErrorDisplay);
      setIsLoading(false);
      window.scrollTo(0, 0);
      return;
    }

        const salesAgreementObj = makeSalesAgreementObj(salesAgreements);
        
        if (isNew) {
          try {
            const response = await PrepayNewPaymentMethodV2(
              isNew,
              "easypay",
              data,
              customerNumber,
              salesAgreementObj,
              ""
            );

            if(typeof response.error === "undefined"){
    
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                event: "account_action",
                category: "Account",
                action: "payments",
                label: `prepay initiated - ${
                  data.isCreditCard ? "Card" : "Account"
                }`,
                customer_id: customerNumber || {},
                error: {
                  reason: "",
                },
              });

              dispatch(setBypassAccountDetailsCache(true));
      
              let checkedData = sessionStorage.getItem("paymentlist");
              let parseList = JSON.parse(checkedData);
              if (data.isCreditCard && !data.isAccount) {
                parseList[0].successData = {
                  method: data.cashSubType,
                  confirmation: response,
                  data: {
                    pccAcctLast4: data["Card Number"].slice(-4),
                  },
                };
              } else {
                parseList[0].successData = {
                  method: "CHK",
                  confirmation: response,
                  data: {
                    pccAcctLast4: data.tokenNum.slice(-4),
                  },
                };
              }
      
              sessionStorage.setItem("paymentlist", JSON.stringify(parseList));
      
              return response;
            } else {
                setErrorMsg(`An error has occurred in processing the payment. Please contact Customer Care at ${customerServiceNumberFormatted}`);
                window.scrollTo(0, 0);
            }
          } catch (error) {
            
            if(error?.genericMessage)
              setErrorMsg(error?.genericMessage);
            else
              setErrorMsg(`An error has occurred in processing the payment. Please contact Customer Care at ${customerServiceNumberFormatted}`);
            window.scrollTo(0, 0);
          } finally {
            setIsLoading(false);
          }
        } else {
          try {
            const response = await PrepayExistingPaymentMethodV2(
              isNew,
              "easypay",
              data,
              customerNumber,
              salesAgreementObj,
              ""
            );
    
            if (response && response.status === 500) {
              throw response.error || "Internal Server Error";
            }
    
            if(typeof response.error === "undefined"){
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                event: "account_action",
                category: "Account",
                action: "payments",
                label: `enrollment initiated - ${paymentData.pccCashType === 'CCD' ? 'Card' : 'Account'}`,
                customer_id: customerNumber || {},
                error: {
                  reason: "",
                },
              });

              dispatch(setBypassAccountDetailsCache(true));
      
              let checkedData = sessionStorage.getItem("paymentlist");
              let parseList = JSON.parse(checkedData);
              if (data.pccCashType!=="CHK") {
                parseList[0].successData = {
                  method: data.pccCashSubType,
                  confirmation: response,
                  data: {
                    pccAcctLast4: data.pccTokenNum.slice(-4),
                  },
                };
              } else {
                parseList[0].successData = {
                  method: "CHK",
                  confirmation: response,
                  data: {
                    pccAcctLast4: data.pccTokenNum.slice(-4),
                  },
                };
              }
      
              sessionStorage.setItem("paymentlist", JSON.stringify(parseList));
      
              return response;
            } else {
              setErrorMsg(`An error has occurred in processing the payment. Please contact Customer Care at ${customerServiceNumberFormatted}`);
              window.scrollTo(0, 0);
            }
          } catch (error) {
            setErrorMsg(`An error has occurred in processing the payment. Please contact Customer Care at ${customerServiceNumberFormatted}`);
            window.scrollTo(0, 0);
          } finally {
            setIsLoading(false);
          }
        }
  };

  return (
    <>
      {error != "" && <ErrorBlock labels={labels} errMsg={error} />}
      {error == "" && isLoading && <OverLayLoader isOpen={true} />}
    
      <div className={`${styles["enrollContainer"]}`}>
        <div className="mb-20 row">
          <div className={`${styles["enrollHeader"]}`}>
            <div
              className={`${styles["enrollTitle"]}`}
              dangerouslySetInnerHTML={{ __html: label.easyPayEnrolled }}
            ></div>&nbsp;

            <div className={`${styles["settingsLink"]}`}>
              <Link
                className="link"
                to="/my-account/account-settings/easypay-settings"
              >
                <span
                  dangerouslySetInnerHTML={{
                    __html: label.manageEasyPaySettings,
                  }}
                />
              </Link>
            </div>
          </div>

          <div className="col-12 gfw-3 p-0">
            <span
              className={`${styles["sectionTitle"]}`}
              dangerouslySetInnerHTML={{ __html: label.easyPaySetup }}
            />
            <span className={`${styles["sectionSubtitle"]}`}>
              {label.descriptionEE}
            </span>
            <span
              className={`${styles["sectionSubtitle"]}`}
              dangerouslySetInnerHTML={{ __html: label.serviceChoiceEE }}
            />
          </div>
        </div>

        {error == "" && isLoadingSelectionBlock
         ? <Loader />
         : check.length ? (
            <>
              <div className={`${styles["selectionBlock"]} row`}>
                <SelectionBlock paymentData={check} setHasSelection={setHasSelection} ref={selectedInvoiceRef} isPaymentSubmitted={isPaymentSubmitted} />
              </div>

              {hasSelection &&
              <div className={`${styles["paymentBlock"]}`}>
                <PaymentBlock
                  paymentDataProp={paymentData}
                  handleDataSubmit={handleSubmit}
                  hasSelection={hasSelection}
                />
              </div>
              }
            </>
            )
            : <NoEasyPayService labels={labels} msg={`No services available for <span class='font-italic'><strong class='gfw-7'>Easy</strong>Pay</span> enrollment.`} />
        }
      </div>
    </>
  );
};

export default Enroll;